import { API_JWT_BASE_URL } from '../http'

export const SEARCH_OTAP_AGENT_QUEUES_API = `${API_JWT_BASE_URL}/OtapAgentQueues/search`
export const GET_OTAP_AGENTS_API = `${API_JWT_BASE_URL}/OtapAgentQueues`

export const OTAP_AGENT_QUEUES_QUERY_KEYS = {
  SEARCH_OTAP_AGENT_QUEUES: 'SEARCH_OTAP_AGENT_QUEUES',
  GET_OTAP_AGENTS: 'GET_OTAP_AGENTS'
}
